import { latest as LatestVDETypes } from '@libs/waymark-video/video-descriptor-types';
import { BaseLayer } from './BaseLayer';

/**
 * A layer that references a sub-composition.
 */
export class UnsupportedLayer extends BaseLayer<
  Exclude<
    LatestVDETypes.Layer,
    // Omit officially supported layer types
    | LatestVDETypes.TextLayer
    | LatestVDETypes.ImageLayer
    | LatestVDETypes.WaymarkVideoLayer
    | LatestVDETypes.WaymarkAudioLayer
    | LatestVDETypes.ShapeLayer
    | LatestVDETypes.SolidLayer
    | LatestVDETypes.PreCompLayer
    | LatestVDETypes.NullLayer
  >
> {
  toString(): string {
    return `UnsupportedLayer-${this.rawLayerData.ty}<${this.getUUID()}>`;
  }
}
